import { getConstant } from '../utils';

export const getNDMI = getConstant('GET_NDMI');
export const getNDVI = getConstant('GET_NDVI');
export const getNDVIandNDMI = getConstant('GET_NDMI_AND_NDVI');
export const getSWI = getConstant('GET_SWI');
export const setUUID = getConstant('SET_UUID');